import type { ReactNode } from 'react';

import { TriangleAlert } from 'lucide-react';

import { cn } from '@shared/utils/cn';
import { Button } from '@shared/components/ui/button';

type Props = {
  title?: string;
  message?: string;
  /** False inside a layout: the fallback fills the content area instead of the screen. */
  fullPage?: boolean;
  /** Replaces the default retry button. */
  children?: ReactNode;
};

/** Fallback when a provider or a page cannot be displayed: readable message and a way out. */
export const FatalError = ({
  title = 'Une erreur est survenue',
  message = 'Impossible de charger les paramètres.',
  fullPage = true,
  children,
}: Props) => (
  <div
    className={cn('flex flex-col items-center justify-center gap-4 p-6 text-center', fullPage ? 'min-h-svh' : 'flex-1')}
    role="alert"
  >
    <div className="flex size-14 items-center justify-center rounded-full bg-destructive/10 text-destructive">
      <TriangleAlert className="size-7" />
    </div>
    <div>
      <h1 className="text-lg font-semibold">{title}</h1>
      <p className="mt-1 text-sm text-muted-foreground">{message}</p>
    </div>
    {children ?? (
      <Button onClick={() => window.location.reload()} variant="outline">
        Réessayer
      </Button>
    )}
  </div>
);
